export const PERMS = {
    READ: 'surcharge_types.read',
    UPDATE: 'surcharge_types.update',
    DELETE: 'surcharge_types.delete',
    CREATE: 'surcharge_types.create',
    EXPORT: 'surcharge_types.export',
}
